export const ComplianceBoxes = [
  {
    image: '/assets/information/compliance/wages_hours.svg',
    icon: ['fal', 'chess-clock'],
    heading: 'Wage & Hour',
    slug: '/compliance/wage_hour',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/workplace_safety.svg',
    icon: ['fal', 'fire-extinguisher'],
    heading: 'Workplace Safety & Health',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/compliance/workplace_safety_health',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/workers_comp.svg',
    icon: ['fal', 'money-bill'],
    heading: "Workers' Compensation",
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/compliance/workers_comp',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/employee_benefits.svg',
    icon: ['fal', 'umbrella'],
    heading: 'Employee Benefits',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/compliance/employee_benefits',
    top_border: false,
    mid_border: false,
    bot_border: false,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/veteran_rights.svg',
    icon: ['fal', 'medal'],
    heading: "Veteran's Rights",
    subheading: 'Software, Internet, Mobile, Telecommunication',
    slug: '/compliance/veteran_rights',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/garnish_wages.svg',
    icon: ['fal', 'hand-holding-usd'],
    heading: 'Garnishment of Wages',
    subheading: 'Books, Textbooks, More Books',
    slug: '/compliance/garnish_wages',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/family_leave_act.svg',
    icon: ['fal', 'baby'],
    heading: 'The Family and Medical Leave Act',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/compliance/family_leave_act',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/compliance/layoffs.svg',
    icon: ['fal', 'hand-point-right'],
    heading: 'Plant Closings & Layoffs',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/compliance/layoffs',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
];

export const Compliances = {
  wage_hour: {
    main_heading: 'Wage & Hour',
    main_subheading:
      'Wage and hour regulations are some of the most comprehensive and nuanced in the Department of Labor. Failure to comply can result in expensive litigation claims for businesses of every size and kind. Bambee will make sure your business is compliant, and protected from risk.',
    the_law:
      "<p class='subheader'>The <strong>Fair Labor Standards Act (FLSA)</strong> requires " +
      'the following of businesses:</p>' +
      '<ul>' +
      '<li><span>Payment of at least the federal minimum wage to non-exempt employees</span>' +
      '<ul>' +
      '<li><span>Covered, nonexempt workers are entitled to a minimum wage of $7.25 per hour effective July 24, 2009.</span></li>' +
      '</ul>' +
      '</li>' +
      '<li><span>Overtime pay of at least one-and-one-half-times the regular pay rate</span></li>' +
      '<li><span>Restrictions on working hours for children under 16</span></li>' +
      '<li><span>Restrictions on dangerous work for children under 18</span></li>' +
      '<li><span>Specific safety and wage protections for migrant and seasonal agricultural workers under ' +
      'the <strong>Migrant and Seasonal Agricultural Worker Protection Act (MSPA)</strong>.</span></li>' +
      '<li><span>Enforcement of the labor standards provisions of the <strong>Immigration and Nationality Act (INA)</strong>, which applies to non-U.S. citizens authorized to work in the U.S. under certain nonimmigrant visa programs (H-1B, H-1B1, H-1C, H2A)</span></li>' +
      '</ul>',
    the_risk:
      '<p>Businesses typically violate wage and hour laws in two areas:</p>' +
      "<p class='subheader'>Improper payment for hours worked</p>" +
      '<p>Claims brought in the hours worked category refer to an employer’s ' +
      'failure to pay for all hours worked. This could happen, for example, if an ' +
      'employer asked their employee to work during their lunch break, or beyond ' +
      'their scheduled hours without overtime pay.</p>' +
      "<p class='subheader'>Incorrect exemptions</p>" +
      '<p>Making an employee exempt might seems like an attractive time and ' +
      'money-saving option as they do not require tracking for hours worked or overtime ' +
      'pay. However, not every role meets the requirements for this categorization. To ' +
      'qualify for exemption, an employee must:</p>' +
      '<ul>' +
      '<li><span>Be paid a set salary of at least $455/week</span></li>' +
      '<li><span>Be performing executive, professional, or administrative duties, or be ' +
      'designated as computer professionals or outside sales associates</span></li>' +
      '<li><span>Not be performing non-exempt duties for more than half their working hours.</span></li>' +
      '</ul>',
    disclaimer:
      "<br/><p class='subheader'>Failure to comply with the FLSA can result in employers being forced to provide up to 3 years of back-pay for employees seeking recovered wages. Additionally, businesses accused of being in violation are often audited completely. These audits often lead to expensive class action suits, which could mean a loss of hundreds of thousands for your business if you’re found to be in violation.</p>",
  },
  workplace_safety_health: {
    main_heading: 'Workplace Safety & Health',
    main_subheading:
      'Following every Department of Labor safety regulation is crucial to running a safe ' +
      'and efficient workplace, but it can be somewhat complicated in practice. Failure to comply can not ' +
      'only result in citations and fines for businesses your business - it can lead to serious injury or ' +
      'death of employees. Bambee will make sure your business is compliant with all guidelines, so you can ' +
      'work safely and avoid risk.',
    the_law:
      '<p>The <strong>Occupational Safety and Health Administration (OSHA)</strong> ' +
      'mandates ' +
      'workplace health and safety regulations to keep businesses free of health threats. ' +
      'OSHA has unique guidelines for each industry and its specific safety risks, ' +
      'specifically for industries with greater opportunities for workplace hazards ' +
      'such as construction, mining, maritime, and agricultural work. </p>' +
      "<br/><p class='subheader'>OSHA requires employers to</p>" +
      '<ul>' +
      '<li><span>Inform employees of workplace hazards and seek to prevent them through appropriate training</span></li>' +
      '<li><span>Reduce hazards by modifying working conditions, if necessary</span></li>' +
      '<li><span>Keep records of workplace injuries and illnesses</span></li>' +
      '<li><span>Perform regular safety tests</span></li>' +
      '<li><span>Offer OSHA compliant medical tests to employees</span></li>' +
      '<li><span>Post OSHA posters displaying common workplace risks and hazards in an area visible to employees during the workday</span></li>' +
      '<li><span>Notify OSHA within 8 hours if there is a workplace incident resulting in death or hospitalization of 3 or more employees</span></li>' +
      '<li><span>Not penalize employees who come forward with complaints regarding violations</span></li>' +
      '</ul>' +
      "<br/><p class='subheader'>OSHA does not require compliance from:</p>" +
      '<ul>' +
      '<li><span>Workers who are self employed</span></li>' +
      '<li><span>Workers protected by another Federal agency</span></li></ul>',
    the_risk:
      '<p>There are six categories of OSHA violations. Each come with their own recommendations and penalties.</p>' +
      '<ul>' +
      "<p class='subheader'>De Minimis Violations</p>" +
      '<p>De minimis violations are the least significant of all OSHA infractions. They refer to violations that are ' +
      'technically non-compliant with OSHA standards, but have no direct negative effect on workplace health and safety. ' +
      'Consequences for de minimis violations include verbal warnings and notations on the employer’s case inspection file.</p>' +
      '' +
      "<p class='subheader'>Other-than-Serious Violations</p>" +
      '<p>Other-than-serious violations refer to infractions that would probably not lead to workplace injury or death, but are unsafe nonetheless. For example, failure to post proper safety signage is considered an other-than-serious violation. Consequences for other-than-serious violations include a maximum fine of $7,000.</p>' +
      '' +
      "<p class='subheader'>Serious Violations</p>" +
      '<p>OSHA violations that are obvious and have a high likelihood ' +
      'of resulting in injury or death are categorized as serious violations. ' +
      'Consequences for serious violations include a maximum fine of $7,000, ' +
      'dependent on how dangerous the violation and how quickly the business ' +
      'complies upon notification.</p>' +
      '' +
      "<p class='subheader'>Willful Violations</p>" +
      '<p>Willful violations are the most serious OSHA infractions. ' +
      'They refer to intentional negligence of safety regulations, and ' +
      'indifference to the health of employees. Consequences for willful ' +
      'violations include a mandatory fine of up to $70,000. In the case ' +
      'of an employee being killed as a result of OSHA non-compliance, ' +
      'the violation is a criminal offense and incurs a fine of $250,000 ' +
      'for an individual, $500,000 for a corporation. Conviction of a ' +
      'willful violation offense that results in fatality can result in ' +
      'a six month prison sentence.</p>' +
      '' +
      "<p class='subheader'>Repeated Violation</p>" +
      '<p>Committing an infraction noted in a previous ' +
      'inspection falls under the category of repeated violations, ' +
      'and can cost a business up to $70,000.</p>' +
      '' +
      "<p class='subheader'>Failure to Abate Prior Violation</p>" +
      '<p>Failure to resolve a violation noted in a previous ' +
      'inspection by the given deadline falls under the category of repeated ' +
      'violations, and can cost a business up to $70,000.</p>' +
      '' +
      '</ul>',
    disclaimer: '',
  },
  workers_comp: {
    main_heading: "Workers' Compensation",
    main_subheading:
      "Providing workers' compensation is not only required by law, it is crucial in avoid " +
      'the costly and time consuming lawsuits that follow uncompensated and unreported workplace injury. ' +
      'Bambee will make sure you stay compliant with all regulations, so your business is protected from ' +
      'risk.',
    the_law:
      "<p class='p'>Workers’ compensation is an insurance that provides medical " +
      'expense coverage or reimbursement for employees who are either injured on the ' +
      'job or become ill as a result of their work. All business owners must pay for ' +
      'workers’ compensation insurance. Each state has its owner workers’ compensation laws.</p>' +
      "<p class='subheader'>The Office of Workers’ Compensation Programs (OWCP) has four major compensation programs:</p>" +
      '<ul><li><span>Wage replacement benefits</span></li>' +
      '<li><span>Medical treatment</span></li>' +
      '<li><span>Vocational rehabilitation</span></li>' +
      '<li><span>Other benefits</span></li>' +
      '</ul>' +
      "<br/><p class='subheader'>Employees are typically eligible for workers’ compensation if:</p>" +
      '<ul>' +
      '<li><span>They are injured on the job, regardless of whether or not the workplace is non-compliant with OSHA regulations</span></li>' +
      '<li><span>They have a preexisting condition exacerbated by their work</span></li>' +
      '<li><span>They have an injury or health issue related to workplace stress</span></li>' +
      '</ul>' +
      "<br/><p class='subheader'>Employees are typically not eligible if they are injured as a result of personal negligence.</p>",
    the_risk:
      "<p class='subheader'>Common workers' compensation violations include:</p>" +
      '<ul>' +
      '<li><span>Failure to provide workers’ compensation insurance</span></li>' +
      '<li><span>Failure to post appropriate safety signage in an area visible to employees</span></li>' +
      '<li><span>Insubstantial safety training that leaves employees vulnerable to injury</span></li>' +
      '<li><span>Incomplete or inaccurate incident reporting</span></li>' +
      '<li><span>Failure to file wage statement for injured employees</span></li>' +
      '<li><span>Failure to deliver payment/benefits to employee within a given the timeframe</span></li>' +
      '<li><span>Incorrect compensation amount for injured employee</span></li>' +
      '</ul>' +
      "<br/><p class='subheader'>These violations can result in fines from state and federal departments, as well as expensive lawsuits from affected employees.</p>",
  },

  employee_benefits: {
    main_heading: 'Employee Benefits',
    main_subheading:
      'Regulations around employee benefits are complex, and change regularly. Bambee will ' +
      'help make these understandable, and ensure your business is compliant.',
    the_law:
      '<p>The Employment Retirement Income Security Act (ERISA) sets minimum standards for private company pensions, welfare, and health benefits. The law does not require companies to offer plans, but it does regulate for those who do.</p>' +
      "<p class='subheader'>Specifically, ERISA sets standards for</p>" +
      '<ul>' +
      '<li><span>How long employees must work to receive benefits</span></li>' +
      '<li><span>Length of leave employees can take without change in benefits</span></li>' +
      '<li><span>Whether an employee’s spouse has a right to their benefits in the event of their death</span></li>' +
      '<li><span>Prohibition of discriminatory practices in benefit disbursement</span></li>' +
      '<li><span>Transparency of information regarding which benefits are offered, how to obtain them, and any plan limitations</span></li>' +
      '<li><span>How claims should be filed, and how they can be appealed if denied</span></li>' +
      '<li><span>Reporting on benefits and accountability to the federal government for plan fiduciaries</span></li>' +
      '<li><span>Participant rights to sue for benefits in the case of violation</span></li>' +
      '</ul>',
    the_risk:
      "<p class='subheader'>Common ERISA violations include:</p>" +
      '<ul><li><span>Illegally denying benefits</span></li>' +
      '<li><span>Improper maintenance of records</span></li>' +
      '</ul>' +
      "<br/><p class='subheader'>ERISA violations are punishable by both civil and criminal penalties</p>" +
      '<ul>' +
      '<li><span>Civil penalties typically include payment of benefits owed, as well as court costs and any other fees incurred by the affected employee as a result of denial of benefits.</span></li>' +
      '<li><span>Criminal penalties are determined by the severity of violation. For example, if an employer is found to have wilfully violation ERISA to deny benefits, they can face fines up to $100,000 and be jailed up to 10 years.</span></li>' +
      '</ul>',
    disclaimer: '',
  },

  veteran_rights: {
    main_heading: "Veteran's Rights",
    main_subheading:
      'Service members have special workplace rights in accordance with the Department of ' +
      'Labor, and failing to comply with them can cost you. Bambee will make sure your company is following ' +
      'all veteran regulations, so you can stay protected from risk.',
    the_law:
      '<p>The Uniformed Services Employment and Reemployment Rights Act (USERRA), ' +
      "administered by the Veterans' Employment and Training Service (VETS), protects the " +
      'rights of military personnel to obtain civilian employment upon return from active ' +
      'duty. Specifically, it assures an individual’s right to be reemployed in a job they ' +
      'left to perform military service.</p>' +
      "<p class='subheader'>An employer cannot deny a veteran employment, reemployment, promotion, " +
      'or any benefit of employment as long as this veteran:</p>' +
      '<ul>' +
      '<li><span>Notifies their employer of their service in advance</span></li>' +
      '<li><span>Serves for five or less cumulative years while working for a given employer</span></li>' +
      '<li><span>Applies for reemployment quickly after the end of their military service</span></li>' +
      '<li><span>Was not dishonorably discharged</span></li>' +
      '</ul>',
    the_risk:
      "<p class='subheader'>Common USERRA violations include: </p>" +
      '<ul>' +
      '<li><span>Denial of reemployment</span></li>' +
      '<li><span>Lack of effort to retrain returning veteran in their previous role</span></li>' +
      '<li><span>Denial of benefits, or any aspect of previous role such as title, pay, or seniority</span></li>' +
      '</ul>',
    disclaimer:
      "<br/><p class='subheader'>Consequences for employer violations can include court-ordered compliance, compensation for lost wages, and hefty fines.</p>",
  },

  garnish_wages: {
    main_heading: 'Garnishment of Wages',
    main_subheading:
      'Court ordered wage garnishment for employees is a personal matter, but there are ' +
      'regulations around it that businesses must comply with. Bambee will make sure your business is ' +
      'compliant and covered.',
    the_law:
      '<p>Wage garnishment is the court ordered withholding of earnings directly ' +
      'from an employee’s paycheck (typically for payment for child support, bankruptcy, or ' +
      'tax payments). The Consumer Credit Protection Act (CCPA) forbids employers to ' +
      'discriminate against employees with wage garnishment. It also limits the amount ' +
      'of earnings that may be withheld in a given week.</p>',
    the_risk:
      '<p>Employers found guilty of discharging an employee because of their ' +
      'wage garnishment situation may have to reinstate their employment, and pay wages ' +
      'lost during unemployment. If the violation is determined to be willful, the employer ' +
      'may be fined up to $1000, imprisoned for a year, or both.</p>',
    disclaimer: '',
  },

  family_leave_act: {
    main_heading: 'The Family and Medical Leave Act',
    main_subheading:
      'Employees have rights to protected time off work during specific personal situations, ' +
      'and companies risk expensive lawsuits and full audits if they fail to comply. Bambee will make sure your ' +
      'business follows regulations and stays protected.',
    the_law:
      '<p>The <strong>Family and Medical Leave Act (FMLA)</strong> ' +
      'requires businesses with 50 or more employees to offer up to 12 weeks of unpaid, ' +
      'protected leave under circumstances for specific family and medical reasons.</p>' +
      "<p class='subheader'>Protect circumstances include:</p>" +
      '<ul>' +
      '<li><span>Parental leave around birth or adoption</span></li>' +
      '<li><span>Serious illness of an employee or their family member</span></li>' +
      '<li><span>Qualifying exigencies related to a member’s military deployment</span></li>' +
      '</ul>',
    the_risk:
      "<p class='subheader'>Common FMLA violations include:</p>" +
      '<ul>' +
      '<li><span>Employer failure to recognize qualifying conditions, such as severity of illness</span></li>' +
      '<li><span>Disciplining of employees’ with absences that are actually covered by FMLA</span></li>' +
      "<li><span>Requiring employees' to give more notice of absence than is required by law</span></li>" +
      '<li><span>Employer failure to maintain benefits coverage during and after absence</span></li>' +
      '<li><span>Not reinstating a returning employee to their previous role </span></li>' +
      '</ul>',
    disclaimer:
      "<br/><p class='subheader'>Violation can result in a personal or federal lawsuit brought to force compliance, and fines for non-compliance.</p>",
  },

  layoffs: {
    main_heading: 'Plant Closings & Layoffs',
    main_subheading:
      'The Department of Labor has guidelines for businesses that are closing or downsizing. ' +
      "Make sure you're covered and compliant by talking to Bambee first.",
    the_law:
      '<p>The Worker Adjustment and Retraining Notification Act (WARN) provides ' +
      'protection for employees affected by layoffs through mandatory notice by employers ' +
      'prior to the termination event. </p>' +
      "<p class='subheader'>Specific provisions of WARN include:</p>" +
      '<ul>' +
      '<li><span>60 days advance notice of plant closings at companies with 100 or more employees if event will affect 50 or more employees</span></li>' +
      '<li><span>60 days advance notice of mass layoffs at companies with 500 or more employees</span></li>' +
      '<li><span>Notification to employees themselves or to their appropriate labor union</span></li>' +
      '</ul>',
    the_risk:
      '<p>Failure to provide appropriate notice can result in penalties of up to $500 for each day of violation. </p>',
  },
};
